import React from "react"
import Table from "../Table"
export default () => {
  return <Table ownership="public" />
}